import React, {
    FunctionComponent,
    useContext,
    useEffect,
    useState
} from 'react';

// Next utils
import Link from 'next/link';
import Router, { useRouter } from 'next/router';

// Material ui
import {
    ListItem,
    ListItemText
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Variables
import VARIABLES from '@/assets/variables';

// Icons
import { EmptyIcon } from '@/assets/icons';

// Styles
import './MenuItem.scss';

// Context
import { MenuContext } from '@components/UI-KIT/Menu';

interface IconProps {
    color?: string
}

interface Props {
    href: string,
    label: string,
    icon?: FunctionComponent<IconProps>,
    onClick?: () => void,
}

const MenuItem: React.FC<Props> = ({
    href,
    label,
    icon,
    onClick
}) => {
    const [ selected, setSelected ] = useState(false);
    const { expanded } = useContext(MenuContext);

    const url = useRouter().asPath;

    useEffect(() => {
        setSelected(url.split('/')[1] === href.split('/')[1]);
    }, [ url ]);

    return (
        <Link
            passHref
            href={href}
        >
            <ListItem
                data-name={!expanded ? label : undefined}
                button
                disableRipple
                component="a"
                className={`ui-Menu-item${!expanded ? ' ui-Menu-collapsed' : ''}`}
                onClick={() => {
                    onClick();
                    Router.replace(href);
                }}
            >
                { icon
                    ? selected
                        ? icon({ color: VARIABLES.palette.secondary_color })
                        : icon({})
                    : <EmptyIcon />}
                { expanded && (
                    <ListItemText
                        className="ui-Menu-link-label"
                    >
                        <Typography
                            variant="table-regular"
                            color={selected ? 'secondary' : 'content'}
                        >
                            {label}
                        </Typography>
                    </ListItemText>
                )}
            </ListItem>
        </Link>
    );
};

export default MenuItem;
